export default __webpack_public_path__ + "static/media/img13.01961b5c.PNG";